module.exports = __webpack_public_path__ + "static/img/cnc4.8873ef9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/cnc4.jpg
// module id = yUw+
// module chunks = 2